import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24.66 24" {...props}><path d="M-.001 5.268v18.735h18.283V5.268H-.001M18.799 5.206l5.859-4.5V19.56l-5.859 4.188zM6.369.28c.213-.019 18.291 0 18.291 0l-6.357 4.67-18.2-.083z" fill="#6c7778" /><path d="M12.974 0L7.041 4.8V13H10.7V4.8L16.862 0z" fill="#fff" /></svg>);